(() => {
  if (window.__pdpProductDetailsLoaded) return;
  window.__pdpProductDetailsLoaded = true;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const productHashPattern = /^#product-(description|size-fit|size-guide|shipping-delivery|returns)$/;

  const findTarget = (hash) => {
    if (!productHashPattern.test(hash)) return null;
    const target = document.getElementById(hash.slice(1));
    if (!target?.closest('[data-pdp-canonical-details]')) return null;
    return target;
  };

  const revealTarget = (target) => {
    const details = target.closest('details');
    if (details && !details.open) details.open = true;

    const focusTarget = target.matches('summary')
      ? target
      : target.querySelector('[data-pdp-details-focus]') || target;

    window.requestAnimationFrame(() => {
      try {
        focusTarget.focus({ preventScroll: true });
      } catch (_error) {
        focusTarget.focus();
      }
      target.scrollIntoView({
        behavior: reducedMotion.matches ? 'auto' : 'smooth',
        block: 'start',
      });
    });
  };

  const openHash = (hash = window.location.hash) => {
    const target = findTarget(hash);
    if (target) revealTarget(target);
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[data-pdp-details-anchor]');
    if (!link) return;

    const url = new URL(link.href, window.location.href);
    const target = findTarget(url.hash);
    if (!target) return;

    event.preventDefault();
    if (window.location.hash === url.hash) {
      window.history.replaceState(null, '', url.hash);
    } else {
      window.history.pushState(null, '', url.hash);
    }
    revealTarget(target);
  });

  window.addEventListener('hashchange', () => openHash());
  document.addEventListener('shopify:section:load', () => openHash());

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => openHash(), { once: true });
  } else {
    openHash();
  }
})();
